// Logs Jitsi's own call events to the console as "[call] ...", so a stuck
// mic/camera on the live server can be traced (Jitsi itself logs very little).
export function logJitsiEvents(api) {
  const events = [
    'videoConferenceJoined', 'videoConferenceLeft', 'audioMuteStatusChanged', 'videoMuteStatusChanged',
    'audioAvailabilityChanged', 'videoAvailabilityChanged', 'cameraError', 'micError', 'deviceListChanged',
    'errorOccurred', 'peerConnectionFailure', 'p2pStatusChanged', 'suspendDetected', 'videoQualityChanged',
    'participantJoined', 'participantLeft', 'conferenceError',
  ];
  events.forEach((name) => {
    try { api.on(name, (data) => console.info(`[call] ${name}`, data ?? '')); } catch { /* unknown event in this Jitsi build */ }
  });
}
